import React from "react";

export const CurrencyRendererRed = (data, type) => {
  if (data === null) return "";
  if (type === "sort") {
    return Math.abs(data);
  }
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  if (data < 0) {
    return (
      '<span class="text-danger">' +
      formatter.format(Math.round(data)).slice(0, -3) +
      "</span>"
    );
  } else if (data >= 0) {
    return formatter.format(Math.round(data)).slice(0, -3);
  }
};

export const CurrencyRenderer = (data, type) => {
  if (data === null) return "";
  if (type === "sort") {
    return Math.abs(data);
  }
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(Math.round(data)).slice(0, -3);
};

export const CurrencyRendererPrice = (data, type) => {
  if (data === null) return "";
  if (type === "sort") {
    return Math.abs(data);
  }
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return data ? formatter.format(data) : data;
};

export const NumberRenderer = (data) => {
  if (data === null) return "";
  let nf = Intl.NumberFormat();
  return nf.format(Math.round(data));
};

export const DecimalRenderer = (data, decimalPlaces) => {
  if (data === null) return "";
  let nf = Intl.NumberFormat();
  return nf.format(Number.parseFloat(data).toFixed(decimalPlaces));
};

export const PercentRenderer = (data, decimalPlaces) => {
  if (data === null) return "";
  let f = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: decimalPlaces,
  });
  return f.format(data);
};

export const GetParams = (state, returnObj) => {
  let obj = {};

  if (state.group) {
    obj.year = state.group.substring(0, 4);
    if (state.group.split("-").length > 1) {
      obj.month = state.group.substring(5, 7);
    }
  }
  if (state.agg) {
    obj.agg = state.agg;
  }
  if (state.date) {
    obj.date = state.date;
  }
  if (state.dateEnd) {
    obj.dateEnd = state.dateEnd;
  }
  if (state.start) {
    obj.x0 = state.start;
  }
  if (state.end) {
    obj.x1 = state.end;
  }
  if (state.firm) {
    obj.firm = state.firm;
  }
  if (state.acct) {
    obj.acct = state.acct;
  }
  if (state.sybl) {
    obj.sybl = state.sybl;
  }
  if (state.tag) {
    obj.tag = state.tag;
    obj.tagAndMode = state.tagAndMode;
  }
  obj.token = state.auth.token;
  obj.user = state.auth.user;

  if (returnObj) {
    return obj;
  }

  let p = new URLSearchParams([...Object.entries(obj)]);

  return p.toString();
};

export const DisplayTimeEnd = (props) => {
  let time = "N/A";
  if (props.end) {
    time = props.end.substring(11, 19);
  } else if (props.endTS) {
    time = props.endTS.substring(11, 19);
  }
  return <span>At: {time}</span>;
};

export const DisplayTimeRange = (props) => {
  let stime = "N/A";
  let etime = "N/A";
  if (props.start) {
    stime = props.start.substring(11, 19);
  } else if (props.startTS) {
    stime = props.startTS.substring(11, 19);
  }
  if (props.end) {
    etime = props.end.substring(11, 19);
  } else if (props.endTS) {
    etime = props.endTS.substring(11, 19);
  }
  return (
    <span>
      {stime} - {etime}
    </span>
  );
};

export const MWBaseURL = () => {
  return process.env.REACT_APP_MW_BASE_URL;
};

export const Handle403 = (props) => {
  window.top.location.href = process.env.REACT_APP_RE_AUTH_URL;
};

export const GetESTDateString = (date) => {
  let d = date ? date : new Date();
  //return new Date(d.getTime() - (d.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
  let s = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
  return s.slice(-4) + "-" + s.slice(0, 2) + "-" + s.slice(3, 5);
};

export const GetStandardDTButtons = (tbltitle, showAll) => {
  return [
    ...(showAll
      ? [
          {
            extend: "collection",
            className: "btn btn-sm btn-secondary",
            init: function (api, node, config) {
              node.removeClass("dt-button");
              node.children(".dt-down-arrow").remove();
            },
            text: 'Complete <svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Download:"><use xlink:href="#download-icon"/></svg>',
            buttons: function () {
              return [
                "copyHtml5",
                "csvHtml5",
                "excelHtml5",
                "pdfHtml5",
                "print",
              ].map((x) => ({
                extend: x,
                exportOptions: { orthogonal: "export" },
                title: tbltitle,
              }));
            },
          },
          {
            extend: "collection",
            className: "btn btn-sm btn-secondary",
            init: function (api, node, config) {
              node.removeClass("dt-button");
              node.children(".dt-down-arrow").remove();
            },
            text: 'Visible <svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Download:"><use xlink:href="#download-icon"/></svg>',
            buttons: function () {
              return [
                "copyHtml5",
                "csvHtml5",
                "excelHtml5",
                "pdfHtml5",
                "print",
              ].map((x) => ({
                extend: x,
                exportOptions: { orthogonal: "export", columns: ":visible" },
                title: tbltitle,
              }));
            },
          },
        ]
      : []),
    {
      extend: "colvis",
      columns: ":not(.nocolvis)",
      className: "btn btn-sm btn-secondary",
      init: function (api, node, config) {
        node.removeClass("dt-button");
        node.children(".dt-down-arrow").remove();
      },
    },
  ];
};
